export default __webpack_public_path__ + "static/media/misc-closet2-1440w.7a81b1d4.png";